module.exports = __webpack_public_path__ + "static/media/calendar2.caa9892c.svg";